"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _chunk6104512b = require("./chunk-6104512b.js");

var _CFontIcon = _interopRequireDefault(require("./CFontIcon.js"));

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

require("./layout.js");

require("./chunk-b15f6972.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = (0, _chunkB2edacfb.a)(["\n  background: ", ";\n  border-radius: ", ";\n  color: #fff;\n  display: none;\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: normal;\n  padding: 10px 16px;\n  position: absolute;\n  text-align: left;\n  text-transform: none;\n  white-space: ", ";\n  width: ", ";\n  z-index: 1000;\n  text-align: center;\n  &.tooltip-pos-top {\n    /* arrow */\n    &:after {\n      top: 100%;\n      left: 50%;\n      border: solid transparent;\n      content: \" \";\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n      border-color: rgba(136, 183, 213, 0);\n      border-top-color: rgba(8, 23, 49, 1);\n      border-width: 10px;\n      margin-left: -10px;\n    }\n    /* position */\n    bottom: calc(100% + 13px);\n    right: calc(-100px + 25%);\n  }\n  &.tooltip-pos-bottom {\n    /* arrow */\n    &:after {\n      bottom: 100%;\n      left: 50%;\n      border: solid transparent;\n      content: \" \";\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n      border-color: rgba(136, 183, 213, 0);\n      border-bottom-color: rgba(8, 23, 49, 1);\n      border-width: 10px;\n      margin-left: -10px;\n    }\n    /* position */\n    top: calc(100% + 13px);\n    right: calc(-97px + 25%);\n  }\n  &.tooltip-pos-left {\n    /* arrow */\n    &:after {\n      top: 50%;\n      transform: translateY(-50%);\n      left: 105%;\n      border: solid transparent;\n      content: \" \";\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n      border-color: rgba(136, 183, 213, 0);\n      border-left-color: rgba(8, 23, 49, 1);\n      border-width: 10px;\n      margin-left: -10px;\n    }\n    /* position */\n    top: 50%;\n    right: calc(100% + 13px);\n    transform: translateY(-50%);\n  }\n  &.tooltip-pos-right {\n    /* arrow */\n    &:after {\n      top: 50%;\n      transform: translateY(-50%);\n      right: 100%;\n      border: solid transparent;\n      content: \" \";\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n      border-color: rgba(136, 183, 213, 0);\n      border-right-color: rgba(8, 23, 49, 1);\n      border-width: 10px;\n      margin-left: -10px;\n    }\n    /* position */\n    top: 50%;\n    left: calc(100% + 13px);\n    transform: translateY(-50%);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: inline-block;\n  position: relative;\n  /* Depending, you may need to include the following in the specific Component using the tooltip:\n  position: absolute;\n  z-index: 1; */\n  &:hover .tooltip-tip {\n    display: block;\n    cursor: pointer;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CToolTip = function CToolTip(props) {
  var className = props.className,
      position = props.position,
      wrap = props.wrap,
      width = props.width,
      children = props.children,
      icon = props.icon,
      tip = props.tip,
      boxProps = props.boxProps,
      iconBoxProps = props.iconBoxProps;
  return _react.default.createElement(Wrapper, {
    className: className
  }, children || _react.default.createElement(_CFontIcon.default, (0, _chunkB2edacfb.g)({}, iconBoxProps, {
    className: icon
  })), _react.default.createElement(Tip, (0, _chunkB2edacfb.g)({
    wrap: wrap,
    width: width,
    className: "tooltip-tip tooltip-pos-".concat(position)
  }, boxProps), tip));
};

CToolTip.propTypes = {
  position: _propTypes.default.string,
  wrap: _propTypes.default.string,
  width: _propTypes.default.string,
  icon: _propTypes.default.string,
  children: _propTypes.default.node
};
CToolTip.defaultProps = {
  position: "top",
  wrap: "pre-wrap",
  width: "auto",
  icon: "fas fa-info-circle"
};

var Wrapper = _styledComponents.default.span.withConfig({
  displayName: "CToolTip__Wrapper",
  componentId: "sc-134wahy-0"
})(_templateObject());

var Tip = (0, _styledComponents.default)(_chunk6104512b.a).withConfig({
  displayName: "CToolTip__Tip",
  componentId: "sc-134wahy-1"
})(_templateObject2(), function (props) {
  return props.theme["$smurfs-blood"];
}, function (props) {
  return props.theme["$border-radius"];
}, function (props) {
  return props.wrap;
}, function (props) {
  return props.width;
});
CToolTip.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CToolTip",
  "props": {
    "position": {
      "defaultValue": {
        "value": "\"top\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "wrap": {
      "defaultValue": {
        "value": "\"pre-wrap\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "width": {
      "defaultValue": {
        "value": "\"auto\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "icon": {
      "defaultValue": {
        "value": "\"fas fa-info-circle\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};
var _default = CToolTip;
exports.default = _default;
CToolTip.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CToolTip",
  "props": {
    "position": {
      "defaultValue": {
        "value": "\"top\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "wrap": {
      "defaultValue": {
        "value": "\"pre-wrap\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "width": {
      "defaultValue": {
        "value": "\"auto\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "icon": {
      "defaultValue": {
        "value": "\"fas fa-info-circle\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};